jQuery(document).ready(function ($) {

	//SMOOTH SCROOL
	$('.roll a').click(function(event) {
		var target = $(this.getAttribute('href'));
		if( target.length ) {
			event.preventDefault();
			$('html, body').stop().animate({
				scrollTop: target.offset().top
			}, 1000);
		}
	});

	//ABRIR MENU MOBILE
	$('.abrir-menu-container, .menu-mobile .botao-fechar').click(function(e) {
		e.preventDefault();
		if(!$('.menu-mobile').hasClass('menu-site-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	$('.menu-overlay').click(function(e) {
		e.preventDefault();
		if(!$('.menu-overlay').hasClass('menu-overlay-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	function abreMenu() {
		$('.menu-mobile').addClass('menu-site-aberto');
		$('.menu-overlay').addClass('menu-overlay-aberto');
	}
	function fechaMenu() {
		$('.menu-mobile').removeClass('menu-site-aberto');
		$('.menu-overlay').removeClass('menu-overlay-aberto');
	}

	//BALAO DO WHATS
	$('a.whats').click(function(e) {
		closeWhatsBallon();
	});

	$('.whats-balao').hover(function(e) {
		closeWhatsBallon();
	});

	function closeWhatsBallon() {
		$('.whats-balao').remove();
	}

	setTimeout( function() { closeWhatsBallon(); }, 10000);

	//CARROSSEIS
	$('.agenda-carrosel').owlCarousel({
		loop:false,
		margin:10,
		autoplay:false,
		autoplayTimeout:5000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: true,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:3
			}
		}
	});

	$('.destaques-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:true,
		autoplayTimeout:8000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: true,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:3
			}
		}
	});

	$(function() {
		var owl = $('.propostas-carrossel'),
			owlOptions = {
				loop:true,
				margin:30,
				autoplay:true,
				autoplayTimeout:4000,
				dots:false,
				lazyLoad: true,
				navText:["&#8592;","&#8594;"],
				autoHeight: true,
				nav:true,
				responsive:{
					0:{
						items:1
					},
					600:{
						items:1
					},
					1000:{
						items:2
					}
				}
			};

		if ( $(window).width() < 768 ) {
			var owlActive = owl.owlCarousel(owlOptions);
		} else {
			owl.addClass('off');
		}

		$(window).resize(function() {
			if ( $(window).width() < 854 ) {
				if ( $('.propostas-carrossel').hasClass('off') ) {
					var owlActive = owl.owlCarousel(owlOptions);
					owl.removeClass('off');
				}
			} else {
				if ( !$('.propostas-carrossel').hasClass('off') ) {
					owl.addClass('off').trigger('destroy.owl.carousel');
					owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
				}
			}
		});
	});

});

window.onscroll = function() { fixHeader() };
const header = document.getElementById("topo");
function fixHeader() {
	if (window.pageYOffset > 1) {
		header.classList.add("scrooled");
	} else {
		header.classList.remove("scrooled");
	}
}